import React, {Component} from 'react';
import Button from "react-bootstrap/Button";
import EmbedLinkInput from "./EmbedLinkInput/EmbedLinkInput";

class EmbedLinksInput extends Component {

    addGameInfoLink = (type = 'ITCH_LINK') => {
        const newLink = {
            game_embed_link_id: null,
            game_embed_link: "",
            game_name: "",
            link_type: type,
            valid: false,
        };
        // console.log(type)
        const updatedLinks = {...this.props.embedLinks};
        if (type === 'ITCH_LINK') {
            // console.log("if")
            updatedLinks.itch_embed = [...updatedLinks.itch_embed, newLink]
        } else {
            // console.log("else")
            updatedLinks.game_embed = [...updatedLinks.game_embed, newLink]
        }
        // console.log(updatedLinks)
        this.props.embedLinksUpdate(updatedLinks);
    };

    handleInputChange = (index, key, value, valid, type = 'ITCH_LINK') => {
        let updateVal = {...this.props.embedLinks};
        if (type === 'GAME_EMBED') {
            updateVal.game_embed[0] = {...updateVal.game_embed[0], [key]: value, valid: valid}
        } else if (type === 'ITCH_LINK') {
            updateVal.itch_embed = updateVal.itch_embed.map((link, i) =>
                i === index ? { ...link, [key]: value, valid: valid} : link
            );
        }
        this.props.embedLinksUpdate(updateVal);
    };

    handleRemoveLink = (index, type = 'ITCH_LINK') => {
        let updateVal = {...this.props.embedLinks};
            if (type === 'GAME_EMBED') {
            updateVal.game_embed = [];
        } else if (type === 'ITCH_LINK') {
            // console.log("rar")
            updateVal.itch_embed = updateVal.itch_embed.filter((_, i) => i !== index);
            // console.log(updateVal.itch_embed)

        }
        this.props.embedLinksUpdate(updateVal);
    };

    render() {
        const { embedLinks, hasBeenConfirmed } = this.props;
        const gamelinks = embedLinks.game_embed;
        const itchLinks = embedLinks.itch_embed;
        const itchEmbedLinksInputElement = itchLinks && itchLinks.length ? (
            <>
                <dd className="col-sm-9">
                    {itchLinks.map((infoLink, index) => (
                        <EmbedLinkInput

                            key={index}
                            index={index}
                            infoLink={infoLink}
                            onInputChange={this.handleInputChange}
                            onRemoveLink={this.handleRemoveLink}
                            hasBeenConfirmed={hasBeenConfirmed}
                        />
                    ))}
                </dd>
                <dt className="col-sm-3"></dt>
            </>
        ) : null;

        const gameEmbedLink = gamelinks && gamelinks.length > 0 && <>
            <dd className="col-sm-9">
                <EmbedLinkInput
                    isGameLink={true}
                    key={0}
                    index={0}
                    infoLink={gamelinks[0]}
                    onInputChange={this.handleInputChange}
                    onRemoveLink={this.handleRemoveLink}
                    hasBeenConfirmed={hasBeenConfirmed}
                /></dd>
            <dt className="col-sm-3"></dt>
        </>

        return (
                this.props.isGame ?
                <dl className="row">
                    <dt className="col-sm-3">
                        <label>WebGL Game Embed Link:</label>
                    </dt>
                    {gameEmbedLink}
                    <dd className="col-sm-9">
                        {(!gamelinks || gamelinks.length === 0) && (
                                <Button
                                    className="col-sm-12"
                                    variant="outline-primary"
                                    onClick={() => this.addGameInfoLink('GAME_EMBED')}
                                >
                                    Embed A Game Demo
                                </Button>)
                        }
                    </dd>
                </dl>
                    :
                <dl className="row">
                    <dt className="col-sm-3">
                        <label>Itch Page Embed Links:</label>
                    </dt>
                    {itchEmbedLinksInputElement}
                    <dd className="col-sm-9">
                            <Button
                                className="col-sm-12"
                                variant="outline-primary"
                                onClick={() => this.addGameInfoLink()}
                            >
                                Embed An Itch Link
                            </Button>
                    </dd>
                </dl>
        );
    }
}

export default EmbedLinksInput;
